import React, { useEffect, useState } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { RiEditFill } from "react-icons/ri";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useCountries } from "use-react-countries";
import Select from "react-select";
import { getcountry } from "../../hook/useapi";
import Loading from "../common/Loading";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const customStyles = {
  control: (provided) => ({
    ...provided,
    padding: "5px",
    backgroundColor: "#f5f5f5",
  }),
  control: (base) => ({
    ...base,
    minWidth: 100,
    borderRadius: "6px",
    // border: "0.5px solid #095228",
    padding: "5px 5px",
    backgroundColor: "#f5f5f5",
  }),
  option: (provided) => ({
    ...provided,
    display: "flex",
    alignItems: "center",
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Ensures it appears on top
};

const SellInfoEdit = ({ profiledate, HandleGEtsellerProfile, sellerId }) => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: profiledate?.name || "",
      email: profiledate?.email || "",
      mobile_number: profiledate?.mobile_number || "",
      website: profiledate?.website || "",
      location: profiledate?.location || "",
      country: profiledate?.country || "",
      currency: profiledate?.currency || "usd",
      Seller_type: profiledate?.seller_type || "",
    },
  });
  const [save, setSave] = useState(false);
  const [loading, setLoading] = useState(false);

  const [country, setCountry] = React.useState(0);
  // const { name, flags, countryCallingCode } = countries[country];
  const { countries } = useCountries();

  useEffect(() => {
    // Re-apply whenever the edit form actually opens (save turns true), not just
    // when profiledate first arrives - the fields may not be mounted yet at that point.
    if (profiledate && save) {
      reset({
        name: profiledate.name,
        email: profiledate.email,
        mobile_number: profiledate.mobile_number,
        website: profiledate.website,
        location: profiledate.location,
        country: profiledate.country,
        currency: profiledate.currency,
        Seller_type: profiledate.seller_type,
      });

      // split mobile for Select + Input
      if (profiledate.mobile_number) {
        const code = countries.find((c) =>
          profiledate.mobile_number.startsWith(c.countryCallingCode)
        );
        setSelectedCountry(code || null);
        setMobile(
          profiledate.mobile_number.replace(code?.countryCallingCode || "", "")
        );
      }
    }
  }, [profiledate, countries, reset, save]);

  const [selectedCountry, setSelectedCountry] = useState(countries[195]); // default
  const [mobile, setMobile] = useState("");

  useEffect(() => {
    if (profiledate?.mobile_number) {
      const [code, number] = profiledate.mobile_number.split("-");
      const foundCountry = countries.find((c) => c.countryCallingCode === code);
      if (foundCountry) setSelectedCountry(foundCountry);
      setMobile(number); // only digits in input
    }
  }, [profiledate, countries]);

  useEffect(() => {
    if (selectedCountry && mobile) {
      setValue(
        "mobile_number",
        `${selectedCountry.countryCallingCode}-${mobile}`
      );
    }
  }, [selectedCountry, mobile, setValue]);

  // console.log(currencydatalist);

  const [currencycode, setCurrencyCode] = useState([]);

  const [counterdata, setCountryData] = useState([]);
  const countrydata = async () => {
    try {
      const resp = await getcountry();
      console.log(resp);
      setCountryData(resp.result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    countrydata();
  }, []);

  const handlecorrencycode = async () => {
    try {
      const resp = await axios.get(
        `${API_BASE_URL}/seller/get-all-currency-code`,
        {
          headers: {
            token:
              sessionStorage.getItem("accessToken") ||
              localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
        }
      );
      // console.log(resp);
      setCurrencyCode(resp.data.result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handlecorrencycode();
  }, []);

  const fullMobile = watch("mobile_number");

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const body = {
        seller_id: String(profiledate?.id),
        name: data.name,
        email: data.email,
        mobile_number: data.mobile_number,
        website: data.website,
        location: data.location,
        country: data.country.toUpperCase(),
        currency: data.currency,
        seller_type: data.Seller_type,
      };

      // console.log(data);
      // Send final API request with JSON body
      const resp = await axios.post(
        `${API_BASE_URL}/seller/update-seller-profile`,
        body,
        {
          headers: {
            token:
              sessionStorage.getItem("accessToken") ||
              localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
        }
      );
      setLoading(false);
      setSave(false);
      console.log("Profile created successfully:", resp);
      toast.success("Profile created successfully!");
      HandleGEtsellerProfile();
    } catch (error) {
      console.error("Error submitting form:", error);
      setLoading(false);
      toast.error(error?.response?.data?.message || "Submission failed");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      <div className=" mx-auto p-0  sm:p-5 space-y-8 text-sm">
        <div className="space-y-5 mt-10 sm:mt-5">
          <div className="flex flex-row justify-between border-b-2">
            <p className="text-lg text-[#095228] font-medium">
              Seller Information
            </p>
            {!sellerId &&
              (save === true ? (
                <button
                  onClick={() => setSave(false)}
                  className="text-xs m-1 bg-green-800 py-1 rounded-xl px-3 font-medium text-white file:"
                >
                  Close
                </button>
              ) : (
                <button onClick={() => setSave(true)} className="text-xs">
                  <RiEditFill className="text-[18px]" />
                </button>
              ))}
          </div>
          {save === true ? (
            <div>
              {loading === true ? (
                <div className="flex justify-center mt-28">
                  <Loading />
                </div>
              ) : (
                <form className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
                  {/* Business Name */}
                  <div>
                    <label className="block font-medium mb-1">
                      Business Name
                    </label>
                    <input
                      type="text"
                      value={profiledate.name}
                      {...register("name", {
                        required: "Business Name is required",
                      })}
                      placeholder="Enter Business Name"
                      className="w-full border rounded-md p-3 outline-none focus:ring-2 focus:ring-green-700"
                    />
                    {errors.name && (
                      <p className="text-sm text-red-500">
                        {errors.name.message}
                      </p>
                    )}
                  </div>

                  {/* Email & Mobile */}
                  <div>
                    <div className="flex flex-col sm:flex-row justify-between items-stretch sm:items-center gap-4">
                      <div className="w-full sm:w-1/2">
                        <label className="block font-medium mb-1">Email</label>
                        <input
                          type="email"
                          {...register("email", {
                            required: "Email is required",
                            pattern: {
                              value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                              message: "Enter a valid email address",
                            },
                          })}
                          placeholder="Enter Your Email"
                          className="w-full border rounded-md p-3 outline-none"
                        />
                        {errors.email && (
                          <p className="text-sm text-red-500">
                            {errors.email.message}
                          </p>
                        )}
                      </div>

                      <div className="w-full sm:w-1/2">
                        <label className="text-sm font-medium" htmlFor="mobile">
                          Mobile Number
                        </label>
                        <div className="flex space-x-2 items-center">
                          {/* Country Select */}
                          <Select
                            options={countries}
                            getOptionLabel={(e) => (
                              <div className="flex items-center">
                                <img
                                  src={e.flags.svg}
                                  alt={e.name}
                                  className="h-4 w-4 rounded-full object-cover mr-2"
                                />
                                {e.countryCallingCode}
                              </div>
                            )}
                            getOptionValue={(e) => e.name}
                            value={selectedCountry}
                            onChange={(option) => setSelectedCountry(option)}
                            styles={customStyles}
                            menuPortalTarget={document.body}
                            menuPosition="absolute"
                            placeholder="Select a country"
                          />

                          {/* Show only number part */}
                          <input
                            id="mobile"
                            type="tel"
                            value={mobile}
                            onChange={(e) => setMobile(e.target.value)}
                            placeholder="Mobile Number"
                            maxLength={15}
                            className="w-full border rounded-md p-3 outline-none"
                          />
                        </div>

                        {/* Hidden input for final API value (e.g. +91-7043967319) */}
                        <input type="hidden" {...register("mobile_number")} />
                      </div>
                    </div>
                  </div>

                  {/* Website */}
                  <div>
                    <label className="block font-medium mb-1">Website</label>
                    <input
                      type="text"
                      {...register("website", {
                        validate: (value) =>
                          /^(https?:\/\/)([\w-]+\.)+[\w-]{2,}(\/\S*)?$/.test(
                            value
                          ) ||
                          "Enter a valid URL starting with http:// or https://",
                      })}
                      placeholder="Enter Your Website"
                      className="w-full border rounded-md p-3 outline-none"
                    />
                    {errors.website && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.website.message}
                      </p>
                    )}
                  </div>

                  {/* Location */}
                  <div>
                    <label className="block font-medium mb-1">Location</label>
                    <input
                      type="text"
                      {...register("location", {
                        required: "Location is required",
                      })}
                      placeholder="Enter Your Location"
                      className="w-full border rounded-md p-3 outline-none"
                    />
                    {errors.location && (
                      <p className="text-sm text-red-500">
                        {errors.location.message}
                      </p>
                    )}
                  </div>

                  {/* Country & Currency */}
                  <div className="flex gap-4 flex-col sm:flex-row">
                    <div className="w-full sm:w-1/2">
                      <label className="block font-medium mb-1">Country</label>
                      <select
                        {...register("country", {
                          required: "Country is required",
                        })}
                        defaultValue="United States of America"
                        className="w-full border rounded-md p-3 outline-none"
                      >
                        <option disabled value="United States of America">
                          United States of America
                        </option>{" "}
                        {counterdata.map((res, i) => (
                          <option key={i} value={res.name}>
                            {res?.name}
                          </option>
                        ))}
                      </select>
                      {errors.country && (
                        <p className="text-sm text-red-500">
                          {errors.country.message}
                        </p>
                      )}
                    </div>

                    <div className="w-full sm:w-1/2">
                      <label className="block font-medium mb-1">Currency</label>
                      <select
                        {...register("currency", {
                          required: "Currency is required",
                        })}
                        className="w-full border rounded-md p-3 outline-none"
                      >
                        <option value="usd">USD</option>
                        {currencycode?.map((code) => (
                          <option key={code} value={code}>
                            {code}
                          </option>
                        ))}
                      </select>
                      {errors.currency && (
                        <p className="text-sm text-red-500">
                          {errors.currency.message}
                        </p>
                      )}
                    </div>
                  </div>

                  {/* Seller Type */}
                  <div>
                    <label className="block font-medium mb-2">
                      Seller Type
                    </label>
                    <div className="flex flex-col items-center sm:flex-row gap-6">
                      <label className="w-full sm:w-1/2 cursor-pointer border rounded-lg p-4 flex flex-row items-start gap-2">
                        <input
                          type="radio"
                          value="individual"
                          {...register("Seller_type", {
                            required: "Seller type is required",
                          })}
                          className="accent-green-700"
                        />
                        <div className="flex flex-col items-center justify-center text-center w-full">
                          <img
                            src="/image/indidvilesell.png"
                            alt="Individual Seller"
                            className={`w-[52px] h-[52px] mb-2 transition ${
                              watch("Seller_type") === "individual"
                                ? "opacity-100"
                                : "opacity-30"
                            }`}
                          />
                          <span className="font-medium text-xl">
                            Individual Seller
                          </span>
                        </div>
                      </label>

                      <label className="w-full sm:w-1/2 cursor-pointer border rounded-lg p-4 flex flex-row items-start gap-2">
                        <input
                          type="radio"
                          value="business"
                          {...register("Seller_type", {
                            required: "Seller type is required",
                          })}
                          className="accent-green-700"
                        />
                        <div className="flex flex-col items-center justify-center text-center w-full">
                          <img
                            src="/image/sellericon.png"
                            alt="Business Seller"
                            className={`w-[52px] h-[52px] mb-2 transition ${
                              watch("Seller_type") === "business"
                                ? "opacity-100"
                                : "opacity-30"
                            }`}
                          />
                          <span className="font-medium text-xl">
                            Business Seller
                          </span>
                        </div>
                      </label>
                    </div>
                    {errors.Seller_type && (
                      <p className="text-sm text-red-500">
                        {errors.Seller_type.message}
                      </p>
                    )}
                  </div>

                  <div>
                    <button
                      type="submit"
                      className="px-6 py-2 mt-4 bg-green-800 text-white rounded-full hover:bg-green-900"
                    >
                      Save
                    </button>
                  </div>
                </form>
              )}
            </div>
          ) : (
            <div className="space-y-8">
              <div className="mt-3">
                <p className="text-gray-500 font-medium text-[14px]">
                  Business Name
                </p>
                <p className="text-lg font-medium">
                  {profiledate?.name || "xxxxxxx"}
                </p>
              </div>

              <div className="mt-3 flex sm:flex-row flex-col gap-4 sm:gap-20">
                <div>
                  <p className="text-gray-500 font-medium text-[14px]">Email</p>
                  <p className="text-[16px] font-medium mt-2">
                    {" "}
                    {profiledate?.email || "xxxxxxx"}
                  </p>
                </div>
                <div>
                  <p className="text-gray-500 font-medium text-[14px]">
                    Mobile Number
                  </p>
                  <p className="text-[16px] font-medium mt-2">
                    {" "}
                    {profiledate?.mobile_number || "xxxxxxx"}
                  </p>
                </div>
              </div>

              <div className="mt-3 flex space-x-8">
                <div>
                  <p className="text-gray-500 font-medium text-[14px]">
                    Business Type
                  </p>
                  <div className=" flex flex-row gap-5 mt-3 items-center ">
                    <img
                      src={
                        profiledate?.seller_type === "business"
                          ? "/image/sellericon.png"
                          : "/image/indidvilesell.png"
                      }
                      alt="Business"
                      className="w-[50px] h-[50px]"
                    />
                    <span className="font-medium text-[16px] mt-2">
                      {profiledate?.seller_type}
                    </span>
                  </div>
                </div>
              </div>

              <div className="mt-3 flex sm:flex-row flex-col gap-4 sm:gap-20">
                <div>
                  <p className="text-gray-500 font-medium text-[14px]">
                    Location
                  </p>
                  <p className="text-[14px] font-medium mt-2">
                    {profiledate?.location || "xxxxxxx"}{" "}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SellInfoEdit;
